import { render, staticRenderFns } from "./contact_btn.vue?vue&type=template&id=fd03bf00&"
import script from "./contact_btn.vue?vue&type=script&lang=js&"
export * from "./contact_btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports